
import { Component, Prop, Vue } from "vue-property-decorator";
import AdmButton from "@afe/admirals-dev/src/components/AdmButton/AdmButton.vue";
import AdmSymbol from "@afe/admirals-dev/src/components/AdmSymbol";
import AdmTypography from "@afe/admirals-dev/src/components/AdmTypography";
import Cookie from "js-cookie";
import UAparser from "ua-parser-js";

@Component({
  components: { AdmTypography, AdmButton, AdmSymbol }
})
export default class extends Vue {
  @Prop(String) readonly json!: string;
  config = JSON.parse(this.json);

  cookieName = "APP_BANNER_CLICKED";
  messages = {
    stars: 5,
    link: ""
  };

  isRendered = false;
  isActive = false;
  isClosedByUser = Cookie.get(this.cookieName);

  onClose() {
    this.isActive = !this.isActive;
    Cookie.set(this.cookieName, "1");
  }

  created() {
    const parser = new UAparser();
    const device = parser.getDevice();
    const os = parser.getOS();

    if (
      device.vendor !== "Apple" &&
      (device.type === "mobile" || device.type === "tablet")
    ) {
      this.isRendered = true;
    }

    if (os.name === "Android") {
      this.messages = this.config["android"];
    } else {
      this.messages = this.config["ios"];
    }

    if (!this.isClosedByUser) {
      setTimeout(() => {
        this.isActive = !this.isActive;
      }, 4 * 1000);
    }
  }

  get icons() {
    let result = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= this.messages.stars) {
        result.push({
          icon: "star",
          class: "app-banner--filled"
        });
      } else {
        result.push({
          icon: "star_border",
          class: "app-banner--empty"
        });
      }
    }
    return result;
  }

  get classes() {
    return {
      "app-banner--active": this.isActive
    };
  }
}
